import { IContractValue } from "@components/global/new/ContractSelector/ContractSelector.props";
import { IContractFile } from "@services/contracts";
import {
  ActionContractBase,
  ActionContractEdit,
  ActionContractTypes,
} from "./actionTypes";
import { dev } from "@utils/dev";

interface IState {
  contracts: IContractValue[];
}

const initial: IState = {
  contracts: [],
};

const reducer = (state = initial, action: ActionContractBase): IState => {
  switch (action.type) {
    case ActionContractTypes.SET_CONTRACTS:
      return { ...state, contracts: action.payload };
    case ActionContractTypes.DELETE_CONTRACT:
      return {
        ...state,
        contracts: state.contracts.filter((c) => c.id !== action.payload),
      };
    case ActionContractTypes.EDIT_CONTRACT:
      const pl = (action as ActionContractEdit).payload;
      const idx = state.contracts.findIndex((c) => c.id === pl.id);

      const editedContracts = state.contracts;
      editedContracts[idx] = pl;

      return {
        ...state,
        contracts: editedContracts,
      };

    case ActionContractTypes.ADD_CONTRACT:
      return {
        ...state,
        contracts: [...state.contracts, action.payload],
      };

    case ActionContractTypes.ADD_CONTRACT_FILE: {
      const file = action.payload as IContractFile;
      const contractIndex = state.contracts.findIndex(
        (c) => Number(c.id) === Number(file.contractid)
      );
      if (contractIndex < 0) {
        console.error("No such contract with id " + file.contractid);
        return state;
      }
      const currentContract = state.contracts[contractIndex];
      const newFiles = currentContract.files
        ? JSON.stringify([...currentContract.files, file])
        : JSON.stringify([file]);
      dev.logt("Contracts", "Updated files", {
        newFiles,
        payload: action.payload,
        currentContract,
      });
      return {
        ...state,
        contracts: [
          ...state.contracts.slice(0, contractIndex),
          {
            ...currentContract,
            files: appendFileToContract(file, currentContract),
          },
          ...state.contracts.slice(contractIndex + 1),
        ],
      };
    }

    default:
      return state;
  }
};

function appendFileToContract(
  file: IContractFile,
  contract: IContractValue,
): string {
  try {
    const files: IContractFile[] = [];
    const exists = JSON.parse(contract.files || "[]");
    if (Array.isArray(exists)) {
      files.push(...exists);
    } else {
      if (Object.keys(exists).length > 0) {
        files.push(exists);
      }
      files.push(file);
    }
    return JSON.stringify(files);
  } catch {
    return "{}"; // old version
  }

}

export default reducer;
